module.exports = __webpack_public_path__ + "static/media/fa-regular-400.5d086178.svg";